import { render } from "./Example.vue?vue&type=template&id=d196f980&scoped=true"
import script from "./Example.vue?vue&type=script&lang=js"
export * from "./Example.vue?vue&type=script&lang=js"

import "./Example.vue?vue&type=style&index=0&id=d196f980&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d196f980"]])

export default __exports__